import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { siteSettings } from "@/content/site";

export default function Privacy() {
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-20">
        <div className="overline mb-4">Legale</div>
        <h1 className="font-display text-4xl md:text-5xl mb-8">Privacy Policy</h1>
        <div className="text-[#5C5C59] leading-relaxed whitespace-pre-wrap">{siteSettings.privacy_text}</div>
      </div>
      <Footer settings={siteSettings} />
    </div>
  );
}
